module.exports = __webpack_public_path__ + "assets/img/back.716b5083.png";